///include /assets/js/app/20i/hostshop/renewal-run-config-read-only.js
///include /assets/js/app/p/catalogue.js
///include /assets/js/app/p/sbproduct.js
///include /assets/js/plugins/network-property-set.js
///include /assets/js/app/20i/failed-order-options.js


class SBProvisionQueue extends NetworkPropertySet {
  /**
   * @param {{action: ?string, actionContent: *, condition: *, contract: ?{expiryDate: ?string, id: string, preferredPaymentId: ?string, preferredPaymentType: ?string, preferredRenewalAction: ?string, preferredRenewalMonths: ?number, productCode: ?string, serviceId: ?string, serviceName: ?string, serviceType: string, upstreamRepeatPaymentRef: ?string, linkUser: ?string}, createdAt: string, expectedCharge: ?number, id: number, state: ?string, updatedAt: ?string}} d
   * @param {?RenewalRunConfigReadOnly} renewalConfig
   */
  constructor(d, renewalConfig) {
      super()
      this.action = d.action
      this.actionContent = d.actionContent
      this.condition = d.condition
      this.contract = d.contract
      this.createdAt = d.createdAt ? new Date(d.createdAt) : null
      this.expectedCharge = d.expectedCharge
      this.id = d.id
      this.renewalConfig = renewalConfig
      this.state = d.state
      this.updatedAt = d.updatedAt ? new Date(d.updatedAt) : null
  }

  get networkMethodInfo() {
      return {path: `/s/provisionQueue/${this.id}`}
  }

  get owner() {
      return this.contract && this.contract.linkUser
  }

  get renewalProductCode() {
      if(!this.contract) return null
      if(!this.contract.preferredRenewalAction) return null
      return this.contract.productCode
  }

  get networkPropertyHandlers() {
      return {
          expectedCharge: async () => {
              const result = await $.ajax({
                  method: "get",
                  url: `/s/provisionQueue`,
                  data: {
                      fields: [
                          "expectedCharge",
                      ],
                      selector: {
                          id: this.id
                      },
                  },
              })
              if( result.length > 0 ){
                  return result[0].expectedCharge;
              } else {
                  return null;
              }
          }
      }
  }
}

SBProvisionQueue.prototype.abort = NPSUtil.j(
  SBProvisionQueue,
  "abort"
)

SBProvisionQueue.prototype.resend = NPSUtil.j(
  SBProvisionQueue,
  "resend"
)